import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import storage from 'localforage';
import { persistStore, persistReducer } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import thunk from 'redux-thunk';
import reducers from './reducers';
import { attachStore } from './storeRef';

const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware];

const persistConfig = {
  blacklist: ['navigation'],
  key: 'root',
  stateReconciler: autoMergeLevel2,
  timeout: null,
  storage,
};

const pReducer = persistReducer(persistConfig, reducers);

const store = createStore(pReducer, applyMiddleware(thunk, ...middlewares));

attachStore(store);

const persistor = persistStore(store);

export { store, persistor, sagaMiddleware };
